/* 🤖 this file was generated by svg-to-ts */
export const matIconVerticalShades: {
  name: 'vertical-shades';
  data: string;
} = {
  name: 'vertical-shades',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 19V3H4v16H2v2h20v-2h-2zM14 5v14h-4V5h4zM6 5h2v14H6V5zm10 14V5h2v14h-2z"/></svg>`
};
